import { ProgressBar } from '@hopin-team/ui-progress-bar';
import { calcSpace, COLOR } from '@hopin-team/ui-symbols';
import styled from 'styled-components';

export default styled(ProgressBar)`
  --color-progress-bar: ${COLOR.GREEN['400']};
  --color-progress-track: ${COLOR.GREY['200']};
  margin-top: ${calcSpace(2)};
`;
